import Link from 'next/link'
import React from 'react'
import { FaArrowRight } from 'react-icons/fa'

const features = [
    {
        emoji: "🎁",
        title: "Free Consultation",
        desc: "We assess your fitness level, health history, goals and diet habits — and design a personalised plan before you commit to any package.",
        href: "/sg/personal-trainer/what-to-expect-from-personal-training"
    },
    {
        emoji: "💰",
        title: "40% More Affordable Than Others",
        desc: "By avoiding expensive gym facilities, we make premium personal training more accessible without lowering coaching standards.",
        href: "/sg/personal-trainer/packages"
    },
    {
        emoji: "🔍",
        title: "Transparent Pricing",
        desc: "All prices are listed clearly on our website, so you know exactly what you are paying upfront.",
        href: "/sg/personal-trainer/personal-trainer-rates-singapore"
    },    
    {
        emoji: "📋",
        title: "6-Step Structure",
        desc: "A 6-step methodology: assessment, custom planning, nutrition, training, progress tracking and lifestyle integration.",
        href: "/sg/personal-trainer/why-choose"
    },
    {
        emoji: "🛡️",
        title: "SG-Registered & Trusted",
        desc: "A Singapore-registered company with full-time personal trainers, not freelance brokers.",
        href: "/about-stringssg"
    },
    {
        emoji: "⭐",
        title: "Success Stories",
        desc: "Over 5,000 clients have hit their fitness goals with us — real, measurable results across Singapore.",
        href: "/sg/personal-trainer/success-stories"
    }
];

const FeatureCard = ({ feature }) => {
    return (
        <Link href={feature.href} prefetch={false} className="group block h-full">
            <div className="relative h-full bg-white/5 backdrop-blur-md rounded-2xl p-3 md:p-5 border border-white/10 hover:bg-white/10 hover:border-orange-500/30 hover:scale-[1.01] transition-all duration-300 overflow-hidden">
                {/* Subtle glow on hover */}
                <div className="absolute inset-0 opacity-0 group-hover:opacity-100 transition-opacity duration-500 bg-linear-to-br from-orange-500/5 via-transparent to-amber-500/5 rounded-2xl" />
                
                <div className="relative flex flex-col h-full">
                    <div className="flex items-start gap-2 md:gap-3 mb-1 md:mb-2">
                        <span className="text-xl md:text-2xl shrink-0">{feature.emoji}</span>
                        <h3 className="font-bold text-base text-white/90 group-hover:text-orange-400 transition-colors duration-300">
                            {feature.title}
                        </h3>
                    </div>
                    {/* The whole card is already a link, so the separate "Learn more" row
                        was redundant and cost a line of height on every card. */}
                    <p className="text-sm text-white/50 leading-relaxed grow pl-7 md:pl-10">
                        {feature.desc}
                        <FaArrowRight className="inline-block ml-1.5 mb-0.5 text-2xs text-orange-400/60 group-hover:text-orange-400 group-hover:translate-x-1 transition-all" />
                    </p>
                </div>
            </div>
        </Link>
    );
};

export const PersonalTrainerWhyUs = () => {
    return (
        <section className="relative py-6 md:py-16 overflow-hidden bg-slate-900">
            {/* Mesh gradient blobs */}
            <div className="absolute top-0 left-1/4 w-96 h-96 bg-orange-500/15 rounded-full blur-3xl" />
            <div className="absolute bottom-0 right-1/4 w-80 h-80 bg-amber-400/10 rounded-full blur-3xl" />
            <div className="absolute top-1/2 right-0 w-64 h-64 bg-rose-500/10 rounded-full blur-3xl" />

            <div className="relative z-10 max-w-6xl mx-auto px-3 md:px-4">
                {/* Section Header */}
                <div className="text-center mb-6 md:mb-10">
                    <div className="inline-flex items-center gap-2 bg-white/10 backdrop-blur-sm px-3 py-1.5 rounded-full mb-4">
                        <span className="text-sm">✨</span>
                        <span className="text-xs font-medium text-white/70">Why StringsSG</span>
                    </div>
                    <h3 className="text-2xl md:text-3xl font-extrabold text-white tracking-tight">
                        Why Choose StringsSG Personal Training?
                    </h3>
                </div>

                {/* Features Grid */}
                <div className="grid md:grid-cols-2 gap-3 md:gap-4">
                    {features.map((feature) => (
                        <FeatureCard key={feature.title} feature={feature} />
                    ))}
                </div>
            </div>
        </section>
    );
};
